import { render, staticRenderFns } from "./upload-pedidos-arquivos.vue?vue&type=template&id=b9694fe0"
import script from "./upload-pedidos-arquivos.vue?vue&type=script&lang=js"
export * from "./upload-pedidos-arquivos.vue?vue&type=script&lang=js"
import style0 from "./upload-pedidos-arquivos.vue?vue&type=style&index=0&id=b9694fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports